import React from 'react';
import { AlertTriangle, Package, Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export const BoxLabelDialog = ({ jobs, boxDevice, onConnect, onPrint, onSkip }) => {
  const total = jobs.reduce((n, j) => n + (j.labelInfo.usn_count || 0), 0);
  return (
    <Dialog open={jobs.length > 0} onOpenChange={(o) => { if (!o) onSkip(); }}>
      <DialogContent className="max-w-md" data-testid="box-print-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-orange-600"><AlertTriangle className="w-6 h-6" />Product Labels Printed - Box Sticker Required</DialogTitle>
          <DialogDescription>Now select the box label printer and print box labels.</DialogDescription>
        </DialogHeader>
        <div className="py-2 space-y-3">
          <div className="p-3 bg-green-50 rounded-lg border border-green-200 text-sm text-green-700">
            {total} combo sticker(s) • {jobs.map((j) => j.labelInfo.combo_name || j.labelInfo.combo_barcode).join(', ')}
          </div>
          <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
            <div className="font-medium text-blue-800 mb-2">Box Label Printer</div>
            {boxDevice ? (
              <div className="flex items-center justify-between text-sm text-blue-700">
                <span className="flex items-center gap-2"><Printer className="w-4 h-4" />{boxDevice.productName || 'USB Printer'} <b className="text-green-600">Connected</b></span>
                <Button size="sm" variant="outline" onClick={onConnect}>Change</Button>
              </div>
            ) : (
              <Button onClick={onConnect} variant="outline" className="w-full border-blue-300 text-blue-600" data-testid="select-box-printer-btn"><Printer className="w-4 h-4 mr-2" />Select Box Label Printer</Button>
            )}
          </div>
          <Alert className="bg-yellow-50 border-yellow-300">
            <Package className="h-4 w-4 text-yellow-600" />
            <AlertTitle className="text-yellow-800">Ready to Print</AlertTitle>
            <AlertDescription className="text-yellow-700">{boxDevice ? 'Click "Print Box Labels" to proceed.' : 'Please select the printer with box sticker roll loaded.'}</AlertDescription>
          </Alert>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onSkip} data-testid="skip-box-labels-btn">Skip Box Labels</Button>
          <Button onClick={onPrint} disabled={!boxDevice} className="bg-orange-600 hover:bg-orange-700" data-testid="print-box-labels-btn"><Printer className="w-4 h-4 mr-2" />Print Box Labels</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
